export const SITEKEY = '0x4AAAAAABAdkI8-hQ0mHWSP'
export const PSITEKEY = '1x00000000000000000000AA'
export const CALL_IMAGE = `https://eethsa.xyz/eethsa2/`;
export const CALL_API = "https://eethsa.xyz/eethsa2/api";
